import $ from 'jquery';
import _ from 'underscore';
import './utils';

import { state } from './state-manager/state-model';
import { AppView } from './app-view';
import { starterGuide } from './starter-guide/starter-guide-view';
import { checkAXInstalled, redirectToInstallAX, tryUpdateAX } from './game-starter';
import { initializeUI } from './ui/index';

// NOTE: UI 스크립트를 실행

$(function () {
  var app = new AppView({ model: state });

  initializeUI(app);

  app.on('app:gameLaunching', function () {
    if ($.browser.msie) {
      app.message.show(
        '게임 실행 안내',
        ['게임을 실행하고 있습니다.', '잠시만 기다려 주십시오.'].join('<br>')
      );
      _.delayed(function () {
        app.message.hide();
      }, 5000);
    } else {
      starterGuide.show();

      $(window).one('blur', function () {
        _.delayed(function () {
          starterGuide.hide();
        }, 1000 * 2);
      });

      _.delayed(function () {
        starterGuide.hide();
      }, 1000 * 60); // 1분 후에 무조건 닫음
    }
  });

  /**
   * 보안 서비스 팝업에서 인증 완료 시 호출하는 글로벌 콜백 함수. 레거시 코드 때문에 이름을 변경할 수 없었음.
   * 우회해서 runGame 을 실행해도 서버에서 한 번 더 체크하기 때문에 문제 없음.
   */
  window.go_game2 = function () {
    app.state.authorizeMFA(true);
    app.runGame();
  };

  /**
   * NOTE: IE일 경우만 실행,
   * 1. AX가 설치되어 있으면 버전 체크 후 구 버전이라면 최신 AX로 업데이트 하고
   * 2. 설치되어 있지 않으면 설치 안내 페이지로 리다이렉트 한다.
   */
  if (checkAXInstalled()) {
    tryUpdateAX();
  } else {
    redirectToInstallAX();
  }

  // 글로벌 노출
  // eslint-disable-next-line
  window.__app = app;
});
